import React, { useState } from 'react'

import { Button } from '@material-ui/core'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import { Container, ContentHeader, Page } from 'components'

import { AuditFormContainer } from '../components'
import { SkeletonForm } from '../components/AuditForm/components'

import useFetch from 'hooks/useFetch'
import * as service from 'service'

const ThirdPartyManagementMySuppliersAuditNew = ({ match }) => {
  const { companySupplierId } = match.params

  const [openTour, setOpenTour] = useState(false)

  const { response, refresh } = useFetch(service.dponet.suppliers.get, {
    companySupplierId,
  })

  const companySupplier = response?.data?.companySupplier || null
  const isPreAvaliation = companySupplier?.preAvaliation || false

  return (
    <Page title="Gestão de Fornecedores - Nova Auditoria">
      <Container maxWidth={false}>
        <ContentHeader title="Nova Auditoria">
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
          >
            Tutorial
          </Button>
        </ContentHeader>
        {companySupplier ? (
          <AuditFormContainer
            companySupplier={companySupplier}
            refresh={refresh}
            isPreAvaliation={isPreAvaliation}
            openTour={openTour}
            setOpenTour={setOpenTour}
          />
        ) : (
          <SkeletonForm />
        )}
      </Container>
    </Page>
  )
}

export default ThirdPartyManagementMySuppliersAuditNew
